const FIELDS_TO_BE_SKIPED = {
  FORM_DISPLAY_VALUE_FIELD: '_formDisplayValue',
  FORM_LOCAL_FIELD: '_formLocal',
  FORM_META: '_meta',
  MODEL_VERSION_ID: '_modelVersionId',
  MODEL_ID: '_modelId',
} as const;

export default FIELDS_TO_BE_SKIPED;
